import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { JwtToken, LoginType } from '../types/user.type';
import { CustomAxios } from './api';

// const API_URL = 'https://club.avchain.io/';

class AuthService {  
  async login(loginParm : LoginType) {

    console.log("로그인" + JSON.stringify(loginParm,null,2) )
    const response = await CustomAxios.postLogin(loginParm);
    console.log("login response",response);    
    
    
    if (response) {
      const decodeJwt = jwtDecode<JwtToken>(response.token);
      localStorage.setItem('tokenOrigin', response.token);
      localStorage.setItem('tokenDecode', JSON.stringify(decodeJwt));
      localStorage.setItem('userId', decodeJwt.id);
      
    }
     return response;
  }

  logout() {
    localStorage.removeItem('tokenOrigin');
    localStorage.removeItem('tokenDecode');
    localStorage.removeItem('userId');
  }

  // register(username: string, email: string, password: string) {
  //   return axios.post(API_URL + 'signup', {
  //     username,
  //     email,
  //     password,
  //   });
  // }

  getCurrentToken() {
    const tokenDecode = localStorage.getItem('tokenDecode');      
    if (tokenDecode) return JSON.parse(tokenDecode);
    return null;
  }
  getRawToken() {
    const token = localStorage.getItem('tokenOrigin');
    return token;
  }
  getCurrentUserId() {
    const userId = localStorage.getItem('userId');
    if (userId) return userId;
    return null;
  }

}

export default new AuthService();